export enum APP_INFO {
	NAME = 'vw-oneform',
	VERSION = '1.3.0',
}

export enum FIELD_NAME {
	RGPD_COMUNICACIONES_COMERCIALES = 'lssi',
	RGPD_PERFILADO = 'tmk',

	TREATMENT = 'treatment',
	NAME = 'name',
	SURNAME_1 = 'surname',
	SURNAME_2 = 'secondSurname',
	EMAIL = 'email',
	PHONE_PREFIX = 'phonePrefix',
	PHONE = 'phone',
	CP = 'codigoPostal',
	DNI_TYPE = 'dniType',
	DNI = 'dni',
	BIRTHDAY = 'birthday',
	CITY = 'city',
	PROVINCE = 'province',
	COUNTRY = 'country',
	COMMENT = 'comentario',

	CARLINE = 'carline',
	SALESGROUP = 'salesgroup',
	MOTORIZACION = 'motorizacion',
	PLATE = 'matricula',
	PLATE_COUNTRY = 'paisMatricula',
	MARKETING_CODE = 'marketingCode',
	VEHICLE_PRECONFIGURATION = 'vehiclePreconfiguration',
	OFERTA = 'oferta',
	DEALER = 'dealer',
	SEARCHED_DEALER = 'searchedDealer',
}

export const FIELD_SUFFIX = {
	SUGGESTION_SELECTED: 'suggestionSelected',
} as const;

export enum FORM_SUBMIT_STATUS {
	PENDING = 'pending',
	INVALID = 'invalid',
	SENDING = 'sending',
	SUCCESS = 'success',
	ERROR = 'error',
}

export enum EXTERNAL_LINK {
	POLITICA_PRIVACIDAD = 'https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html',
	POLITICA_PRIVACIDAD_COMERCIALES = 'https://www.volkswagen-comerciales.es/es/volkswagen-espana/datos-privacidad.html',
	EMAIL_ATENCION_CLIENTE = 'atencioncliente@volkswagen.es',
	EMAIL_ATENCION_CLIENTE_COMERCIALES = 'atencioncliente.volkswagencomerciales@volkswagen.es',
}

export enum FORM_MESSAGE {
	GENERIC_ERROR = 'Se ha producido un error. Inténtalo más tarde.',
	CHOOSE_OPTION = 'Selecciona una opción',
	REQUIRED_FIELD = 'Este campo es obligatorio',
	INVALID_FIELDS = 'Por favor, revisa los campos del formulario.',
}
